// extracted by css-extract-rspack-plugin
export default {"cls1":"ReferenceEvaluationPage-cls1_G_Z","cls2":"ReferenceEvaluationPage-cls2_dA- ReferenceEvaluationPage-cls1_G_Z","fadeInUp":"ReferenceEvaluationPage-fadeInUp_6fT"};